import { Component, OnInit, Input, ViewEncapsulation, Optional, OnDestroy } from '@angular/core';
import { IdService } from '../../shared/services/id.service';
import { StepperContainerComponent } from './stepper-container/stepper-container.component';
import { StepsDataService } from './stepsData/steps-data.service';
import { isMobile } from '../../shared/utils/mobile';
import { IStep } from './stepper.types';

@Component({
	selector: 'rbc-stepper',
	templateUrl: './stepper.component.html',
	styleUrls: ['./stepper.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class StepperComponent implements OnInit, OnDestroy {
	@Input() followFlow: string | boolean;
	@Input() id: string;
	@Input() stepNumber: string | boolean;
	@Input() steps: IStep[];

	msg: string = 'Default';
	completed: [];
	progress: number = 0;

	constructor(
		private idService: IdService,
		@Optional() private parentComponent: StepperContainerComponent,
		private stepsDataService: StepsDataService
	) {
		this.id = idService.generate();
	}

	get currentStepIndex(): number {
		return this.stepsDataService.currentStepIndex;
	}

	set currentStepIndex(index: number) {
		this.stepsDataService.currentStepIndex = index;
	}

	get currentStepID(): string {
		return this.stepsDataService.currentStepID;
	}

	set currentStepID(ID: string) {
		this.stepsDataService.currentStepID = ID;
	}

	async ngOnInit() {
		// Use steps if it's a parameter, use the parent component steps otherwise
		if (!this.steps || (this.steps.length === 0 && this.parentComponent)) {
			await setTimeout(() => {}, 10);
			this.steps = this.parentComponent.steps.toArray();
		}
		this.$_Stepper_setPoints();
	}

	ngOnDestroy(): void {
		this.idService.remove(this.id);
	}

	// Update point on click to set the clicked point to active, complete and passed and others to not active
	Stepper_updatePoint(e, key) {
		// If the point changed and the event emitted shows it's active then make the current step the index and id of the point in steps
		// also make it active and the others false if the step has had its active property set to true in the array of steps
		if (e.active || this.steps[key].active) {
			// get the id of the active state and change all other steps to inactive
			this.currentStepID = this.steps[key].id;
			this.currentStepIndex = key;
			const stepsUpdated = this.steps.map(step => {
				step.active = false;
				// if the step is the target step set complete and passed
				if (step.id === e.id) {
					step.completed = e.completed;
					step.passed = e.passed;
				}
				return step;
			});
			this.steps = stepsUpdated;
			this.steps[key].active = true;
		}
		this.update_progress();
	}

	// Set the active point to the first active point in steps
	$_Stepper_resetActive() {
		const currentStepID = this.steps.filter(point => point.active);
		if (currentStepID.length > 0) {
			this.currentStepID = currentStepID[0].id;
		}
	}

	// Used every DOM update to set the points
	$_Stepper_setPoints() {
		this.steps = this.steps.map((point, key) => {
			if (this.followFlow && key !== 0 && !point.completed) {
				point.disabled = true;
			}
			point.id = this.id + '-step' + key;
			return point;
		});
		if (!this.followFlow) {
			const activePoints = this.steps.filter(point => {
				return point.active;
			});
			this.currentStepID = activePoints && activePoints.length ? activePoints[0].id : null;
		} else {
			this.currentStepID = this.steps[0].id;
			this.steps[0].active = true;
		}
	}

	// if followFlow parameter is true than update the progress bar
	update_progress() {
		if (this.followFlow) {
			let flowStep = 0;
			for (let i = 0; i < this.steps.length; i++) {
				if (this.currentStepID === this.steps[i].id) {
					flowStep = i;
				}
			}
			this.progress = flowStep / (this.steps.length - 1);
			setTimeout(() => {});
		}
	}

	isMobileHandler(): boolean {
		return isMobile();
	}
}
